import React from 'react';
import HighlightedBlock from '../highlightedBlock';

export default function WarningBlock(props) {
	return <HighlightedBlock bgColor='#FFC107' {...props} />;
}
